/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 28.06.24
 *
 */
import BaseObject from "@shared/BaseObject.js";
import PriceItem from "@shared/Subscription/PriceItem";
import {Type} from "@qwoach/class-transformer-wrapper"

export default class SubscriptionPricing extends BaseObject {

	@Type(() => PriceItem)
	yearly: PriceItem = new PriceItem("free")

	@Type(() => PriceItem)
	monthly: PriceItem = new PriceItem("free")


	constructor(options = {}) {
		super();

		let {yearly = null, monthly = null} = options

		this.yearly = yearly
		this.monthly = monthly

	}
}
